import styled from "styled-components";
import { HXButton } from "./HXButton";
import { FlexColumn, FlexRowDiv } from "./common.styles";
import { colors } from "healthex-common/colors";
const editRowContentTextWidth = 700;
const editSectionRowContentTextWidth = 850;
export const EditSectionButtonHolder = styled.div `
    width: 100%;
    position: relative;
`;
export const EditSectionIconButton = styled(HXButton).attrs({
    text: true,
}) `
    position: absolute;
    top: 0;
    right: 0;
`;
export const EditSectionSummaryTextContainer = styled(FlexColumn) `
    max-width: ${editSectionRowContentTextWidth}px;
    gap: 8px;
`;
export const EditSectionContentContainer = styled(FlexColumn) `
    gap: 32px;
    align-self: stretch;
`;
export const AdminReviewBanner = styled(FlexRowDiv) `
    max-width: ${editRowContentTextWidth}px;
    border-radius: 4px;
    border: 1px solid ${colors.accents_sunset};
    background: #fff6ee;
    padding: 16px;
    box-sizing: border-box;
`;
